module.exports = __webpack_public_path__ + "img/letras.5320245c.svg";